import { useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";

const empty = {
  player_name: "", parent_name: "", age: 9, dob: "", positions: "",
  email: "", phone: "", medical_notes: "", waiver_accepted: false,
};

export default function Tryouts() {
  const [form, setForm] = useState(empty);
  const [submitted, setSubmitted] = useState(false);
  const set = (k, v) => setForm({ ...form, [k]: v });
  const submit = async (e) => {
    e.preventDefault();
    if (!form.waiver_accepted) { toast.error("Please accept the waiver"); return; }
    try {
      await api.post("/tryouts", { ...form, age: Number(form.age) });
      setSubmitted(true);
      setForm(empty);
      toast.success("Registration received! We'll be in touch.");
    } catch (err) {
      toast.error("Failed to submit");
    }
  };
  return (
    <div data-testid="tryouts-page" className="py-20">
      <div className="max-w-3xl mx-auto px-4 sm:px-6">
        <div className="eyebrow mb-3">Tryouts</div>
        <h1 className="font-display text-5xl sm:text-6xl uppercase font-bold tracking-tight">Become A Kraken</h1>
        <p className="text-slate-400 mt-4">Submit your interest below. We'll reach out with tryout dates, locations, and what to bring.</p>

        {submitted ? (
          <div className="kr-card rounded-xl p-10 mt-10 text-center" data-testid="tryout-success">
            <div className="font-display text-3xl uppercase text-[#00E5FF]">Welcome aboard.</div>
            <p className="text-slate-300 mt-4">Your registration is in. Watch your inbox for tryout details.</p>
            <button onClick={() => setSubmitted(false)} className="btn-ghost mt-6">Submit another</button>
          </div>
        ) : (
          <form onSubmit={submit} className="kr-card rounded-xl p-8 mt-10 space-y-4" data-testid="tryout-form">
            {[
              ["player_name", "Player Name *", "text"],
              ["parent_name", "Parent Name *", "text"],
              ["age", "Age *", "number"],
              ["dob", "Date of Birth *", "date"],
              ["positions", "Positions (comma-separated) *", "text"],
              ["email", "Email *", "email"],
              ["phone", "Phone *", "tel"],
            ].map(([k, label, type]) => (
              <div key={k}>
                <label className="block text-xs uppercase tracking-widest text-[#00E5FF] mb-1">{label}</label>
                <input required={label.includes("*")} type={type} value={form[k]} onChange={(e) => set(k, e.target.value)} className="w-full bg-[#050A15] border border-white/10 rounded-md p-3" data-testid={`tryout-${k}`} />
              </div>
            ))}
            <div>
              <label className="block text-xs uppercase tracking-widest text-[#00E5FF] mb-1">Medical Notes / Allergies</label>
              <textarea rows={3} value={form.medical_notes} onChange={(e) => set("medical_notes", e.target.value)} className="w-full bg-[#050A15] border border-white/10 rounded-md p-3" />
            </div>
            <label className="flex items-start gap-3 text-sm text-slate-300 cursor-pointer">
              <input type="checkbox" checked={form.waiver_accepted} onChange={(e) => set("waiver_accepted", e.target.checked)} data-testid="tryout-waiver" />
              <span>I acknowledge the inherent risks of baseball and accept the Coastal Kraken liability waiver. I confirm the information above is accurate.</span>
            </label>
            <button className="btn-primary w-full justify-center" data-testid="tryout-submit">Submit Tryout Registration</button>
          </form>
        )}
      </div>
    </div>
  );
}
